import { HomeOutlined, MailOutlined, SettingOutlined, CreditCardOutlined, TeamOutlined, LineChartOutlined, CustomerServiceOutlined, StarOutlined, SafetyCertificateOutlined, ExperimentOutlined } from '@ant-design/icons';
import { NAVBAR_PATHS } from './navbar.paths';
import { SCOPES } from '../../../constants/scopes.constants';
import styles from './styles/newSidebar.module.scss';

export { NAVBAR_PATHS, NAVBAR_BRAND_PATH, NAVBAR_ACTIVE_PATH_ALIASES } from './navbar.paths';

export const navbarSections = [
    {
        id: 'dashboard',
        label: 'Home',
        path: NAVBAR_PATHS.dashboard,
        icon: <HomeOutlined className={styles.icon} />,
        requiredScope: SCOPES.DASHBOARD_VIEW,
    },
    {
        id: 'treasury',
        label: 'Cashflow Management',
        path: NAVBAR_PATHS.treasury,
        icon: <MailOutlined className={styles.icon} />,
        requiredScope: SCOPES.TREASURY_VIEW,
    },
    {
        id: 'configurations',
        label: 'Configurations',
        path: NAVBAR_PATHS.configurations,
        icon: <SettingOutlined className={styles.icon} />,
        requiredScope: SCOPES.CONFIGURATIONS_VIEW,
    },
    {
        id: 'billing',
        label: 'Billing',
        path: NAVBAR_PATHS.billing,
        icon: <CreditCardOutlined className={styles.icon} />,
        requiredScope: SCOPES.BILLING_VIEW,
    },
    {
        id: 'team',
        label: 'Team',
        path: NAVBAR_PATHS.team,
        icon: <TeamOutlined className={styles.icon} />,
        requiredScope: SCOPES.TEAM_VIEW,
    },
    {
        id: 'reports',
        label: 'Reports',
        path: NAVBAR_PATHS.reports,
        icon: <LineChartOutlined className={styles.icon} />,
        requiredScope: SCOPES.REPORTS_VIEW,
    },
    {
        id: 'reviews',
        label: 'Reviews',
        path: NAVBAR_PATHS.reviews,
        icon: <StarOutlined className={styles.icon} />,
        requiredScope: SCOPES.REVIEWS_VIEW,
    },
    {
        id: 'uploads-simulator',
        label: 'Uploads Simulator',
        path: NAVBAR_PATHS.uploadsSimulator,
        icon: <ExperimentOutlined className={styles.icon} />,
        requiredScope: SCOPES.UPLOADS_SIMULATOR_RUN,
    },
    {
        id: 'support',
        label: 'Support',
        path: NAVBAR_PATHS.support,
        icon: <CustomerServiceOutlined className={styles.icon} />,
        requiredScope: SCOPES.SUPPORT_VIEW,
    },
    {
        id: 'roles',
        label: 'Roles',
        path: NAVBAR_PATHS.roles,
        icon: <SafetyCertificateOutlined className={styles.icon} />,
        requiredScope: SCOPES.ROLES_VIEW,
    },
];
